/**
 *-------------------------------------------
 * create Simulation filter info actions in redux
 *-------------------------------------------
 */

export const getSimulationFilter = () => {
    return {
        type: 'GET_SIMULATION_FILTER'
    }
}

export const updateSimulationFilter = (filter) => {
    return {
        type: 'UPDATE_SIMULATION_FILTER',
        filter
    }
}

export const clearSimulationFilter = (filter) => {
    return {
        type: 'CLEAR_SIMULATION_FILTER',
        filter
    }
}
